var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedirect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0008 3.4L2.10078 14.3C1.91745 14.4833 1.68411 14.575 1.40078 14.575C1.11745 14.575 0.884115 14.4833 0.700781 14.3C0.517448 14.1167 0.425781 13.8833 0.425781 13.6C0.425781 13.3167 0.517448 13.0833 0.700781 12.9L11.6008 2H6.00078C5.71745 2 5.47995 1.90417 5.28828 1.7125C5.09661 1.52083 5.00078 1.28333 5.00078 1C5.00078 0.716667 5.09661 0.479167 5.28828 0.2875C5.47995 0.0958333 5.71745 0 6.00078 0H14.0008C14.2841 0 14.5216 0.0958333 14.7133 0.2875C14.9049 0.479167 15.0008 0.716667 15.0008 1V9C15.0008 9.28333 14.9049 9.52083 14.7133 9.7125C14.5216 9.90417 14.2841 10 14.0008 10C13.7174 10 13.4799 9.90417 13.2883 9.7125C13.0966 9.52083 13.0008 9.28333 13.0008 9V3.4Z",
    fill: "#F36D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirect);
export default __webpack_public_path__ + "static/media/redirect.231005e0c81e3d547e45c2cb60907cf7.svg";
export { ForwardRef as ReactComponent };